import React, { Fragment } from 'react';
import { render, unescape } from '@croct/md-lite';

/**
 * Renders Markdown string using @croct/md-lite with restricted elements:
 * - Images are rendered as raw text (not <img>)
 * - Lists are disallowed
 */
export const renderMarkdownToReact = (text) => {
    if (!text || typeof text !== 'string') return null;

    try {
        return render(text, {
            text: (node) => node.content,
            bold: (node) => <strong key={node.index}>{node.children}</strong>,
            italic: (node) => <em key={node.index}>{node.children}</em>,
            strike: (node) => <s key={node.index}>{node.children}</s>,
            code: (node) => <code key={node.index}>{node.content}</code>,
            link: (node) => (
                <a key={node.index} href={node.href} target="_blank" rel="noopener">
                    {node.children}
                </a>
            ),
            image: (node) => <Fragment key={node.index}>{unescape(node.source)}</Fragment>,
            paragraph: (node) => (
                <Fragment key={node.index}>
                    {node.children}
                    <br />
                </Fragment>
            ),
            fragment: (node) =>
                Array.isArray(node.children)
                    ? node.children.map((child, i) => <Fragment key={i}>{child}</Fragment>)
                    : node.children,
        });
    } catch (e) {
        return text;
    }
};

const MarkdownText = ({ content, tag: Tag, className, ...rest }) => {
    if (!content) return null;
    const rendered = renderMarkdownToReact(content);

    if (Tag) {
        return (
            <Tag className={className} {...rest}>
                {rendered}
            </Tag>
        );
    }

    return rendered;
};

export default MarkdownText;
